import { Facebook, Instagram, Linkedin } from 'lucide-react';
import TikTokIcon from '../components/icons/TikTokIcon';

// Single source of truth for OpenbooQ's social media presence.
// Consumed by the homepage social row and the footer.
export const socialLinks = [
  { platform: 'Facebook',  url: 'https://www.facebook.com/openbooq',         label: 'Facebook',  Icon: Facebook },
  { platform: 'Instagram', url: 'https://www.instagram.com/openbooq',        label: 'Instagram', Icon: Instagram },
  { platform: 'LinkedIn',  url: 'https://www.linkedin.com/company/openbooq', label: 'LinkedIn',  Icon: Linkedin },
  { platform: 'TikTok',    url: 'https://www.tiktok.com/@openbooq',          label: 'TikTok',    Icon: TikTokIcon },
];
